import React, { useRef, useState, useEffect, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";
import AllCategoriesBlock1 from "./AllCategoriesComponents/AllCategoriesBlock1";
import ReviewsCategoryBlock from "./MainPageComponents.js/ReviewsCategoryBlock";
import AllCategoriesReviews from "./AllCategoriesComponents/AllCategoriesReviews";
import AllCategoriesRecentlyViewed from "./AllCategoriesComponents/AllCategoriesRecentlyViewed";
import AllCategoriesExplain from "./AllCategoriesComponents/AllCategoriesExplain";
import { FaHeart } from "react-icons/fa"; // Import FontAwesome Heart icon
import star from "../Images/star.png";
import { useHistory } from "react-router-dom";
import Rating from "@mui/material/Rating";

import axios from "axios";
import { AppContext, useAppContext } from "./../AppContext";
import ArrowDown from "../Images/ArrowDown.png";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import arrowleft from "../Images/arrowleft.png";
import FilterImage from "../Images/FilterImage.png";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { DownOutlined } from "@ant-design/icons";
import { Dropdown } from "antd";
import AllCategoriesFiltersSearchPage from "./AllCategoriesComponents/AllCategoriesFiltersSearchPage";
import AllCategoriesCartDialog from "./AllCategoriesComponents/AllCategoriesCartDialog";
import AllCategoriesBreadcrumbs from "./AllCategoriesComponents/AllCategoriesBreadcrumbs";
import Drawer from "@mui/material/Drawer";
import CloseImg from "../Images/CloseImg.png";
import shoppingbag from "../Images/shoppingbag.png";
import AllCategoriesOpenMobileDrawer from "./AllCategoriesComponents/AllCategoriesOpenMobileDrawer";
import { useTranslation } from "react-i18next";
import { MyDomain } from "../App";
const label = { inputProps: { "aria-label": "Checkbox demo" } };

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    width:
      window.innerWidth <= 1920
        ? "90%"
        : window.innerWidth <= 2560
        ? "70%"
        : window.innerWidth <= 3840
        ? "60%"
        : "50%", // Full width minus 5% padding on each side
    margin: "0 auto", // Center the modal horizontally
    maxWidth: "none", // Disable the default max width
    borderRadius: 0,
  },
}));

export default function SearchPage() {
  const { t, i18n } = useTranslation();
  const { setOpenLoginPopOver, OpenLoginPopOver } = useAppContext();
  const { CartAmount, setCartAmount } = useContext(AppContext);

  const [data2, setData2] = useState([]);
  const [loading2, setLoading2] = useState(true);

  const GoTo = async (TheId) => {
    try {
      setLoading2(false);
      axios
        .post(`${MyDomain}News/GetOneNews`, TheId, {
          headers: {
            "Content-Type": "application/json", // Ensure the server knows the payload type
          },
        })
        .then((response) => {
          setData2(response.data);
          handleDivClick4(response.data, TheId);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    } catch (err) {
      //setError("Failed to fetch product data");
    } finally {
      setLoading2(true);
    }
  };

  const handleDivClick4 = (TheObject, NameOfCategory) => {
    history.push({
      pathname: `/news/${NameOfCategory}`,
      state: TheObject, // Pass CategoryName here
    });
    scrollToTop2();
  };
  const handleClose2 = () => {
    setOpen2(false);
    setProductChoosed([]);
    setProductChoosed2(0);
    setOBJOfProductChoosed({});
  };

  const MyModal2 = () => {
    return (
      <>
        <React.Fragment>
          <BootstrapDialog
            onClose={handleClose2}
            aria-labelledby="customized-dialog-title"
            open={open2}
            fullWidth
            maxWidth={false} // Disable Material-UI's default width settings
          >
            <DialogTitle
              sx={{ m: 0, p: 2 }}
              id="customized-dialog-title"
            ></DialogTitle>
            <IconButton
              aria-label="close"
              onClick={handleClose2}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 8,
                color: theme.palette.grey[500],
              })}
            >
              <CloseIcon />
            </IconButton>
            <div style={{}}>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "35%",
                    height: "calc(75vh - 55px)",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <img
                    src={ImageChoosed}
                    style={{
                      width: "80%",
                    }}
                  />
                </div>
                <div
                  style={{
                    width: "55%",
                    height: "calc(75vh - 55px)",
                    display: "flex",
                    paddingTop: "1%",
                    paddingBottom: "1%",
                    flexDirection: "column",
                  }}
                >
                  <div style={{ display: "flex" }}>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "500",
                        fontSize: 18,
                        paddingBottom: 40,
                      }}
                    >
                      {ProductChoosed[0]?.name}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "repeat(4, 1fr)",
                      height: "80%",
                    }}
                  >
                    {ProductChoosed.map((product, index) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          width: "100%",
                          height: 100,
                          paddingTop: "5%",
                          paddingLeft: "5%",
                          border:
                            ProductChoosed2 === index
                              ? "1px solid black"
                              : hoveredIndex === index
                              ? "1px solid black"
                              : "1px solid #ccc",
                          cursor: "pointer",
                          flexDirection: "column",
                        }}
                        onClick={() => {
                          setImageChoosed(product.image);
                          setProductChoosed2(index);
                          setOBJOfProductChoosed(ProductChoosed[index]);
                        }}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                      >
                        <img
                          src={product.image}
                          style={{
                            width: 30,
                            height: 30,
                          }}
                        />
                        <p style={{ margin: 0 }}>{product.dropDown}</p>
                      </div>
                    ))}
                  </div>
                  <div
                    style={{
                      height: "20%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                      alignItems: "center",
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <a
                        style={{
                          fontSize: 15,
                        }}
                      >
                        {OBJOfProductChoosed.discount === 0 ? (
                          <></>
                        ) : (
                          <>
                            {OBJOfProductChoosed.theDeal === 1 ? (
                              <>
                                <a
                                  style={{
                                    backgroundColor: "#6b21a8",
                                    color: "white",
                                    margin: 0,
                                    marginBottom: 5,
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                    fontSize: 15,
                                  }}
                                >
                                  -{OBJOfProductChoosed.discount}%
                                </a>
                                <a
                                  style={{
                                    fontSize: 12,
                                  }}
                                >
                                  &nbsp;
                                </a>
                              </>
                            ) : (
                              <>
                                <a
                                  style={{
                                    backgroundColor: "#6b21a8",
                                    color: "white",
                                    fontSize: 12,
                                    paddingLeft: 5,
                                    paddingRight: 5,
                                  }}
                                >
                                  Buy 2 pcs to get -
                                  {OBJOfProductChoosed.discount}% off every{" "}
                                  {OBJOfProductChoosed.theDeal}
                                  {OBJOfProductChoosed.theDeal === 2
                                    ? "nd"
                                    : "th"}{" "}
                                  item
                                </a>
                              </>
                            )}
                          </>
                        )}
                      </a>
                    </p>
                    &nbsp; &nbsp;
                    {OBJOfProductChoosed.discount === 0 ? (
                      <></>
                    ) : (
                      <>
                        {OBJOfProductChoosed.theDeal === 1 ? (
                          <p
                            style={{
                              margin: 0,

                              color:
                                OBJOfProductChoosed.discount === 0 ||
                                OBJOfProductChoosed.theDeal === 2
                                  ? ""
                                  : "red",
                            }}
                          >
                            {calculateTotalPrice(
                              OBJOfProductChoosed.price,
                              1,
                              OBJOfProductChoosed.discount,
                              1
                            )}
                            &nbsp; &nbsp;
                          </p>
                        ) : (
                          <></>
                        )}
                      </>
                    )}
                    <a
                      style={{
                        textDecoration:
                          OBJOfProductChoosed.discount === 0 ||
                          OBJOfProductChoosed.theDeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{OBJOfProductChoosed.price}
                    </a>
                    &nbsp; &nbsp;
                    <button
                      style={{
                        backgroundColor: "#27272a",
                        color: "#fff",
                        border: "none",
                        padding: "10px 20px",
                        cursor: "pointer",
                        fontSize: "16px",
                        width: 200,
                        height: 50,
                      }}
                      onClick={() => {
                        CreateProduct3();
                      }}
                    >
                      {t("profile.Buy")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </BootstrapDialog>
        </React.Fragment>
      </>
    );
  };
  const [dataFromChild, setDataFromChild] = useState([]);
  const [PricingToParent, sendPricingToParent] = useState([]);

  const [data, setData] = useState("");

  // Function to be executed in both parent and child
  const handleClick = (updatedArray1) => {
    setData(updatedArray1); // Update the state with the data
  };

  // State to hold the content
  const [content, setContent] = useState("");

  const [clearAll, setclearAll] = useState("");

  const [delPricing, setdelPricing] = useState(false);

  // Function to handle the button click in the parent
  const handleButtonClick2 = (TheFilter, TheId) => {
    setdelPricing(!delPricing);
  };

  const ClearAllFunc = () => {
    setclearAll([]);
  };
  // State to control whether the content should be shown in the child
  const [showContentInChild, setShowContentInChild] = useState(false);

  // Function to handle the button click in the parent
  const handleButtonClick = (TheFilter, TheId) => {
    setContent({ filter: TheFilter, id: TheId });
    setShowContentInChild(true); // Set to true to show content in the child
  };

  // Function to handle deletion
  const handleDelete = (TheFilter, TheId) => {
    handleButtonClick(TheFilter, TheId);
  };

  // Callback function to receive data from the child
  const handleDataFromChild = (data) => {
    setDataFromChild(data);
  };
  // Callback function to receive data from the child
  const handleDataFromChild2 = (data) => {
    sendPricingToParent(data);
  };

  //DropDownOrDialog section
  const [ProductChoosed, setProductChoosed] = useState([]);
  const [ImageChoosed, setImageChoosed] = useState("");
  const [open2, setOpen2] = useState(false);
  const [OBJOfProductChoosed, setOBJOfProductChoosed] = useState({});
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [ProductChoosed2, setProductChoosed2] = useState(0);
  const CreateProduct3 = (event) => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: OBJOfProductChoosed.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        setCartData(response.data);
        setCartAmount(response.data.userCart.length);

        handleClickOpen(response.data);
      })
      .catch((err) => {
        //setResponseMessage("Error submitting data.");
        console.log(err.response.data);
      });
  };
  //end DropDownOrDialog section

  const CreateProduct4 = (event) => {
    setCartData([]);
    //event.preventDefault();
    const data = {
      UserId: user?.userId,
      IdOfProduct: event, //OBJOfProductChoosed.id,
      AmountOfProduct: 1,
    };
    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
      .then((response) => {
        //setResponseMessage("Data submitted successfully!");
        console.log(response.data);
        setCartData(response.data);
        setCartAmount(response.data.userCart.length);

        handleClickOpen(response.data);
      })
      .catch((err) => {
        //setResponseMessage("Error submitting data.");
        console.log(err.response.data);
      });
  };
  const [MyWidth, setMyWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setMyWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 500,
      behavior: "smooth",
    });
  };

  const scrollToTop2 = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [CodeCat, setCodeCat] = useState("");
  const [NameCat, setNameCat] = useState("");
  const [secondNameCat, setSecondNameCat] = useState("");

  useEffect(() => {
    GetMainCategory();
  }, []);

  const GetMainCategory = (event) => {
    const data = {
      CodeCat: Number(CategoryName), //Number(CategoryName),
    };
    axios
      .post(`${MyDomain}Categories/GetMainCategory`, data) // replace with your API URL
      .then((response) => {
        setCodeCat(response.data.codeCat);
        setSecondNameCat(response.data.secondNameCat);
        setNameCat(response.data.nameCat);
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const [ShowTopSection, setShowTopSection] = useState(true);

  const user = JSON.parse(localStorage.getItem("user"));

  const handleDivClick2 = (CategoryName, ProductId) => {
    CreateRecently(ProductId);
    history.push(`/product/${ProductId}`);
  };

  const handleDivClick = (CategoryTitle, NameOfCategory) => {
    if (CheckBreadcrumbs.includes(Number(CategoryName))) {
      history.push({
        pathname: `/`,
        state: { CategoryTitle }, // Pass CategoryName here
      });
    } else {
      history.push({
        pathname: `/allcategories/${NameOfCategory}`,
        state: { CategoryTitle }, // Pass CategoryName here
      });
    }
  };

  // Function to handle image click and navigation
  const handleDivClick3 = (CategoryName) => {
    history.push(`${CategoryName}`);
  };

  const CreateRecently = (IdOfProduct) => {
    const now = new Date();
    const formattedDate = now.toLocaleDateString("en-GB").split("/").join("-");
    const formattedTime = now.toTimeString().slice(0, 5);

    const data = {
      UserId: user?.userId,
      ProductId: IdOfProduct,
      TheDate: formattedDate,
      TheTime: formattedTime,
    };
    axios
      .post(`${MyDomain}Recently/CreateRecently`, data) // API URL for adding products to the cart
      .then((response) => {
        console.log(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  const CreateProduct2 = (IdOfProduct) => {
    const data = {
      UserId: user?.userId,
      IdOfProduct: IdOfProduct,
      AmountOfProduct: 1, // Default to adding 1 product to the cart
    };

    axios
      .post(`${MyDomain}Cart/AddProductToCart`, data) // API URL for adding products to the cart
      .then((response) => {
        // Update cart data in state
        setCartData(response.data);
        const userCart = response.data?.userCart || [];
        const products = response.data?.products || [];
        // Calculate total price with discount logic
        const totalPrice = userCart.reduce((accumulator, cartItem) => {
          const product = products.find((p) => p.id === cartItem.idOfProduct);
          if (product) {
            const { price, discount, theDeal } = product;
            const { amountOfProduct } = cartItem;
            let total = 0;
            if (theDeal === 1) {
              // Apply discount to all items
              total += price * (1 - discount / 100) * amountOfProduct;
            } else {
              // Apply discount only to every nth item
              for (let i = 1; i <= amountOfProduct; i++) {
                if (i % theDeal === 0) {
                  total += price * (1 - discount / 100);
                } else {
                  total += price;
                }
              }
            }
            return accumulator + total;
          }
          return accumulator; // If no matching product, skip
        }, 0);
        setSaveTotalPrice(totalPrice);
        setCartAmount(response.data.userCart.length);
      })
      .catch((error) => {
        console.log("Error adding product to cart:", error);
      });
  };
  const handleClickOpen = async (NewData) => {
    setCartData(NewData);
    const userCart = NewData?.userCart || [];
    const products = NewData?.products || [];
    // Safely calculate total price with discount logic
    const totalPrice = userCart.reduce((accumulator, cartItem) => {
      const product = products.find((p) => p.id === cartItem.idOfProduct);
      if (product) {
        const { price } = product;
        const { amountOfProduct } = cartItem;
        let total = 0;
        if (product.theDeal === 1) {
          // Apply discount to all items
          total += price * (1 - product.discount / 100) * amountOfProduct;
        } else {
          // Apply discount only to every nth item
          for (let i = 1; i <= amountOfProduct; i++) {
            if (i % product.theDeal === 0) {
              total += price * (1 - product.discount / 100);
            } else {
              total += price;
            }
          }
        }

        // Add the total for this product to the accumulator
        return accumulator + total;
      }
      return accumulator; // If no matching product, skip
    }, 0);
    setSaveTotalPrice(totalPrice);
    handleOpenDialog();
    //setOpen(true);
  };
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    document.body.style.overflowX = "hidden";
    // Target the .slick-list element within the carousel wrapper div
    const slickList = wrapperRef.current?.querySelector(".slick-list");
    if (slickList) {
      slickList.style.overflow = "visible";
      slickList.style.clipPath = "inset(0px 0px -150px 0px)";
      //slickList.style.paddingBottom = "50px"; // Adjust padding as needed to control dropdown overflow at the bottom
    }
    // Cleanup function to reset body style on component unmount
    return () => {
      document.body.style.overflowX = "";
    };
  }, []);

  const history = useHistory();

  const { CategoryName } = useParams();

  const [ProductsData, setProductsData] = useState([]);
  const [ProductsDataWithoutDub, setProductsDataWithoutDub] = useState([]);

  const [SaveTotalPrice, setSaveTotalPrice] = useState(0);
  const location = useLocation();
  const { CategoryTitle } = location.state || {}; // Access the passed state

  const [AdSectionData, setAdSectionData] = useState([]);
  useEffect(() => {
    const data = {
      CodeCat: CategoryName, //JSON.stringify(CategoryName)
    };
    axios
      .post(`${MyDomain}AdSection/GetAdSectionInCategories`, data)
      .then((response) => {
        console.log(response.data);
        setAdSectionData(response.data.adSections);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  }, []);
  // Create dynamic refs
  const timerRefs = useRef([]);
  const displayRefs = useRef([]);

  // Function to format the time remaining
  const formatTime = (time) => {
    if (time <= 0) return "0 days 0:0:0";

    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / (1000 * 60)) % 60);
    const seconds = Math.floor((time / 1000) % 60);

    return `${days} ${t("profile.days")} ${t(
      "profile.and"
    )} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    const timers = AdSectionData?.map((cardData, index) => {
      const startDate = new Date();
      const endDate = new Date(cardData.dateEnd.split("-").reverse().join("-"));
      let remainingTime = endDate - startDate;

      if (!displayRefs.current[index]) {
        displayRefs.current[index] = React.createRef();
      }
      if (!timerRefs.current[index]) {
        timerRefs.current[index] = { current: null };
      }

      if (displayRefs.current[index].current) {
        displayRefs.current[index].current.innerText =
          formatTime(remainingTime);
      }

      timerRefs.current[index].current = setInterval(() => {
        remainingTime -= 1000;
        if (remainingTime <= 0) {
          clearInterval(timerRefs.current[index].current);
          remainingTime = 0;
        }
        if (displayRefs.current[index].current) {
          displayRefs.current[index].current.innerText =
            formatTime(remainingTime);
        }
      }, 1000);

      return timerRefs.current[index];
    });

    return () => {
      timers.forEach((timerRef) => clearInterval(timerRef.current));
    };
  }, [AdSectionData]);

  const [sortType, setSortType] = useState(t("profile.popularity")); // Default sorting
  const [selectedValue, setSelectedValue] = useState(t("profile.popularity")); // State to manage the selected value

  const items = [
    {
      label: <a>{t("profile.name")}</a>,
      key: "0",
      value: "name", // Associated value
    },
    {
      label: <a>{t("profile.price")}</a>,
      key: "1",
      value: "price", // Associated value
    },
    {
      label: <a>{t("profile.popularity")}</a>,
      key: "2",
      value: "popularity", // Associated value
    },
    {
      label: <a>{t("profile.lowtohigh")}</a>,
      key: "3",
      value: "lowToHigh", // Associated value
    },
    {
      label: <a>{t("profile.hightolow")}</a>,
      key: "4",
      value: "highToLow", // Associated value
    },
  ];

  // Handle item click
  const handleMenuClick = (e) => {
    const selectedItem = items.find((item) => item.key === e.key);
    if (selectedItem) {
      // Update the selected value and sort type
      setSelectedValue(selectedItem.label.props.children); // Extract text from <a>
      setSortType(selectedItem.value); // Update sortType with the associated value
    }
  };

  // Sorting function
  const getSortedList = () => {
    let sortedList = [...currentProducts];

    switch (sortType) {
      case "name": // Sort by name A-Z
        sortedList.sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "price":
        sortedList.sort((a, b) => a.price - b.price);
        break;
      case "lowToHigh":
        sortedList.sort((a, b) => a.price - b.price);
        break;
      case "highToLow":
        sortedList.sort((a, b) => b.price - a.price);
        break;

      default: // Popularity (default)
        sortedList.sort((a, b) => b.popularity - a.popularity);
    }

    return sortedList;
  };

  const [RecommendedProductsData, setRecommendedProductsData] = useState([]);

  const GetRecommendedProducts = () => {
    setRecommendedProductsData([]);

    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}RecommendedProducts/GetRecommendedProductsById`, data)
      .then((response) => {
        console.log(response.data);
        setRecommendedProductsData(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  };
  useEffect(() => {
    GetRecommendedProducts();
  }, []);

  useEffect(() => {
    setCartData([]);
    const data = {
      UserId: user?.userId,
    };
    axios
      .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
      .then((response) => {
        setCartData(response.data);
      })
      .catch((err) => {
        console.log(err.response.data);
      });
  }, []);
  const [CartData, setCartData] = useState([]);

  const calculateTotalPrice = (price, amount, discount, discountOnEvery) => {
    let total = 0;

    for (let i = 1; i <= amount; i++) {
      if (i % discountOnEvery === 0) {
        // Apply discount to every 'discountOnEvery' item
        total += price * (1 - discount / 100);
      } else {
        // Add full price for non-discounted items
        total += price;
      }
    }

    // Format the total to show decimals only when needed
    const formattedTotal = Number.isInteger(total)
      ? total.toString()
      : parseFloat(total.toFixed(2));

    return formattedTotal;
  };

  function ProductCard({
    id,
    productId,
    image,
    title,
    subtitle,
    price: initialPrice,
    discount: initialdiscount,
    deals,
    thedeal: initialthedeal,
    theOBJ,
    news,
    reviews,
    priceinsteadof: initialpriceinsteadof,
  }) {
    const [isDivHovered, setIsDivHovered] = useState(false);
    const [isHeartHovered, setIsHeartHovered] = useState(false);
    //DropDown
    const [price, setPrice] = useState(initialPrice);
    const [priceInsteadOf, setPriceInsteadOf] = useState(initialpriceinsteadof);
    const [hoverPriceInsteadOf, setHoverPriceInsteadOf] = useState(null); // Temporary price for hover

    const [discount, setDiscount] = useState(
      initialdiscount === 0 ? null : price - (price * initialdiscount) / 100
    );
    const [thedeal, setThedeal] = useState(initialthedeal);
    const [hoverThedeal, setHoverThedeal] = useState(null); // Temporary price for hover
    const [hoverDiscount, setHoverDiscount] = useState(null); // Temporary price for hover
    const [hoverPrice, setHoverPrice] = useState(null); // Temporary price for hover
    const [theDiscount, setTheDiscount] = useState(initialdiscount);
    const [hoverTheDiscount, sethoverTheDiscount] = useState(null);
    const [IdOfProduct, setIdOfProduct] = useState(id);
    const [CartData, setCartData] = useState([]);
    const [isOpen, setIsOpen] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const averageRating = Math.floor(
      reviews.reduce((sum, item) => sum + item.rating, 0) / reviews.length
    );
    const [ReviewsProduct, setReviewsProduct] = useState(averageRating);
    const [NumberUsersReview, setNumberUsersReview] = useState(reviews.length);
    const [ListOfUsersReview, setListOfUsersReview] = useState(reviews);

    const showModal = () => {
      setIsModalOpen(true);
    };

    const [selectedOption, setSelectedOption] = useState(""); // Default selected option
    const dropdownRef = useRef(null); // Reference to the dropdown
    const newArray1 = ProductsData.filter(
      (item) => item.productId === productId
    );
    // Extract only the productId values
    const productDropDowns = newArray1.map((item) => item.dropDown);

    const productDropDowns1 = newArray1.map((item) => item);
    const [clickedHearts, setClickedHearts] = useState(
      Array(ProductsData.length).fill(false)
    );
    const toggleDropdown = () => {
      setIsOpen(!isOpen);
    };

    const handleOptionClick = (option) => {
      setSelectedOption(option);
      setIsOpen(false); // Close the dropdown after selecting
    };

    // Close dropdown if clicked outside
    useEffect(() => {
      setCartData([]);
      const data = {
        UserId: user?.userId,
      };

      axios
        .post(`${MyDomain}Cart/GetUserCart`, data) // replace with your API URL
        .then((response) => {
          setCartData(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
      setSelectedOption(productDropDowns[0]);
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false); // Close dropdown if the click is outside the dropdown
        }
      };

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [dropdownRef]);

    const CreateProduct = (event) => {
      setCartData([]);
      //event.preventDefault();
      const data = {
        UserId: user?.userId,
        IdOfProduct: IdOfProduct,
        AmountOfProduct: 1,
      };
      axios
        .post(`${MyDomain}Cart/AddProductToCart`, data) // replace with your API URL
        .then((response) => {
          //setResponseMessage("Data submitted successfully!");
          console.log(response.data);
          setCartData(response.data);
          setCartAmount(response.data.userCart.length);
          showModal();
          handleClickOpen(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };
    // State to track WishList

    const { WishList, setWishList } = useAppContext();

    const AddProductToWishList = async (event) => {
      const data = {
        ProductId: IdOfProduct,
        UserId: user?.userId,
      };
      axios
        .post(`${MyDomain}WishList/AddProductToWishList`, data) // replace with your API URL
        .then((response) => {
          setWishList(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };
    const DeleteFromWishList = async (TheId) => {
      axios
        .delete(`${MyDomain}WishList/DeleteFromWishList`, {
          data: { ProductId: IdOfProduct, UserId: user?.userId },
        })
        .then((response) => {
          setWishList(response.data);
        })
        .catch((err) => {
          console.log(err.response.data);
        });
    };

    const toggleWishlist = async () => {
      const productExists = WishList.some(
        (item) => item.productId === IdOfProduct
      );
      if (productExists) {
        await DeleteFromWishList();
      } else {
        // If product does not exist, add it
        await AddProductToWishList();
      }
    };
    // State to track which products have clicked hearts

    return (
      <div
        onMouseEnter={() => {
          MyWidth <= 1024 ? <></> : setIsDivHovered(true);
        }}
        onMouseLeave={() => {
          MyWidth <= 1024 ? <></> : setIsDivHovered(false);
        }}
        style={{}}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            backgroundColor: "#fafafa",
          }}
        >
          <div
            style={{
              margin: 0,
              backgroundColor: "#27272a",
              transition: "color 0.3s ease",
              cursor: "pointer",
              height: MyWidth <= 1024 ? "50%" : "100%",
            }}
          >
            <p
              style={{
                margin: 0,
                fontSize: "10px",
                color: "white",
                padding: deals !== "" ? 5 : 0,
                paddingLeft: deals !== "" ? 10 : 0,
                paddingRight: deals !== "" ? 10 : 0,
                fontWeight: "bold",
              }}
            >
              {/* {deals} */}
              {deals === "ORIGINAL" ? (
                <>{t("profile.original")}</>
              ) : deals === "MASTER" ? (
                <>{t("profile.master")}</>
              ) : (
                ""
              )}
            </p>
          </div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div
              style={{
                display: "flex",
                padding: 6,
                borderRadius: 50,
              }}
            >
              {/* Heart icon changes color based on hover and click */}
              <FaHeart
                onMouseEnter={() => setIsHeartHovered(true)}
                onMouseLeave={() => setIsHeartHovered(false)}
                onClick={() => {
                  if (user === null) {
                    setOpenLoginPopOver(true);
                    window.scrollTo({
                      top: 0,
                      behavior: "smooth",
                    });
                  } else {
                    toggleWishlist();
                    const updatedClickedHearts = [...clickedHearts];
                    updatedClickedHearts[IdOfProduct] =
                      !updatedClickedHearts[IdOfProduct]; // Toggle heart state
                    setClickedHearts(updatedClickedHearts); // Update the heart clicked state
                  }
                }} // Handle heart click
                style={{
                  fontSize: "18px",
                  color:
                    MyWidth <= 1024
                      ? WishList.some((item) => item.productId === IdOfProduct)
                        ? "#4f46e5"
                        : "#ccc"
                      : isHeartHovered
                      ? "#4f46e5" // Red when hovering over the heart
                      : WishList.some((item) => item.productId === IdOfProduct)
                      ? "#4f46e5"
                      : "#ccc", // Gray when not hovered or clicked
                  transition: "color 0.3s ease",
                  opacity:
                    MyWidth <= 1024
                      ? WishList.some((item) => item.productId === IdOfProduct)
                        ? 1
                        : 1
                      : isDivHovered ||
                        isHeartHovered ||
                        WishList.some((item) => item.productId === IdOfProduct)
                      ? 1
                      : 0,
                  cursor: "pointer",
                }}
              />
            </div>
            {MyWidth <= 1024 ? (
              <div
                style={{
                  display: "flex",
                  padding: 6,
                  borderRadius: 50,
                  cursor: "pointer",
                }}
                onClick={() => {
                  OpenMobileDrawerFunc(productDropDowns1);
                }}
              >
                <img
                  src={shoppingbag}
                  alt={{}}
                  style={{
                    maxHeight: 20,
                    maxWidth: 20,
                    objectFit: "contain",
                  }}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            //flexGrow: 1,
            //height: "350px", // Ensure consistent height
            cursor: "pointer",
            flexDirection: "column",
          }}
          onClick={() => {
            handleDivClick2("product", id);
          }}
        >
          <img
            src={image}
            alt={title}
            style={{
              height: MyWidth <= 1024 ? 150 : 300,
              width: "100%",
              objectFit: "contain",
            }}
          />
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "flex-start",
              height: "30px", // Set a fixed height
              alignItems: "center",
            }}
          >
            {news !== null && (
              <a
                style={{
                  fontSize: 12,
                  backgroundColor: "#6b21a8",
                  padding: 3,
                  margin: 5,
                  color: "white",
                  paddingLeft: 8,
                  paddingRight: 8,
                }}
              >
                {i18n.language === "en"
                  ? news?.typeOfferName
                  : i18n.language === "ar"
                  ? news?.typeOfferNameAr
                  : i18n.language === "he"
                  ? news?.typeOfferNameHe
                  : news?.typeOfferName}
              </a>
            )}
          </div>
        </div>
        <p style={{ fontSize: 18, marginBottom: 1 }}>{title}</p>
        <p style={{ fontSize: 15, opacity: 0.5 }}>{subtitle}</p>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          {NumberUsersReview === 0 ? (
            <>
              <Rating
                name="read-only"
                value={ReviewsProduct}
                readOnly
                sx={{
                  // Make stars bigger
                  fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                  // Add space between stars
                  "& .MuiRating-icon": {
                    color: "black", // Black stars
                    paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                    //paddingTop: 1,
                    opacity: 0.2,
                  },

                  // Ensure filled/hover stars are also black
                  "& .MuiRating-iconFilled": {
                    color: "black",
                  },
                  "& .MuiRating-iconHover": {
                    color: "black",
                  },
                }}
              />
            </>
          ) : (
            <>
              {" "}
              <Rating
                name="read-only"
                value={ReviewsProduct}
                readOnly
                sx={{
                  // Make stars bigger
                  fontSize: "0.75rem", // Adjust size (e.g., 1.5rem, 2rem, etc.)

                  // Add space between stars
                  "& .MuiRating-icon": {
                    color: "black", // Black stars
                    paddingRight: "0 2px", // Adjust spacing (e.g., 0 8px for more space)
                    //paddingTop: 1,
                  },

                  // Ensure filled/hover stars are also black
                  "& .MuiRating-iconFilled": {
                    color: "black",
                  },
                  "& .MuiRating-iconHover": {
                    color: "black",
                  },
                }}
              />
            </>
          )}
          {NumberUsersReview !== 0 ? (
            <a style={{ fontSize: 14, opacity: 0.5 }}>
              &nbsp;{NumberUsersReview}
            </a>
          ) : (
            <>
              <a>&nbsp;</a>
            </>
          )}
          {/* {[1, 2, 3, 4, 5].map((_, idx) => (
                  <img
                    key={idx}
                    src={star}
                    alt="star"
                    style={{
                      width: 8,
                      height: 8,
                      marginLeft: 3,
                      marginBottom: 15,
                    }}
                  />
                ))} */}
        </div>
        <div
          style={{
            flexDirection: "row",
            display: "flex",
            justifyContent: "space-between",
            height: 50,
          }}
        >
          <div
            style={{
              flexDirection: "row",
              display: "flex",
            }}
          >
            <p>
              {hoverDiscount !== null ? (
                hoverDiscount?.toFixed(2) === hoverPrice?.toFixed(2) ? (
                  ""
                ) : (
                  <>
                    {hoverThedeal === 1 ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <a
                          style={{
                            color: "red",
                            fontSize: 15,
                          }}
                        >
                          {hoverTheDiscount === 0 ? "" : <>₪</>}
                          {hoverDiscount?.toFixed(2)}
                          {hoverTheDiscount === 0 ? "" : <>&nbsp; &nbsp;</>}
                        </a>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                )
              ) : discount?.toFixed(2) === price?.toFixed(2) ? (
                ""
              ) : (
                <>
                  {thedeal === 1 ? (
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <a style={{ color: "red", fontSize: 15 }}>
                        {theDiscount === 0 ? "" : <>₪</>}
                        {discount?.toFixed(2)}
                        {theDiscount === 0 ? "" : <>&nbsp; &nbsp;</>}
                      </a>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              )}
            </p>
            <p>
              {hoverPrice !== null ? (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {hoverPriceInsteadOf === 0 ? (
                    <>
                      <a
                        style={{
                          textDecoration:
                            hoverTheDiscount === 0 || hoverThedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{hoverPrice}
                      </a>
                    </>
                  ) : (
                    <>
                      <a
                        style={{
                          textDecoration:
                            hoverTheDiscount === 0 || hoverThedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        <a
                          style={{
                            margin: 0,
                            color: "red",
                            textDecoration: "line-through",
                            fontSize: 15,
                          }}
                        >
                          ₪{hoverPrice}
                        </a>
                        &nbsp;&nbsp;
                        <a
                          style={{
                            textDecoration:
                              hoverTheDiscount === 0 || hoverThedeal === 2
                                ? "none"
                                : "line-through",
                            fontSize: 15,
                          }}
                        >
                          ₪{hoverPriceInsteadOf}
                        </a>
                      </a>
                    </>
                  )}
                </div>
              ) : (
                <>
                  {priceInsteadOf === 0 ? (
                    <a
                      style={{
                        textDecoration:
                          theDiscount === 0 || thedeal === 2
                            ? "none"
                            : "line-through",
                        fontSize: 15,
                      }}
                    >
                      ₪{price}
                    </a>
                  ) : (
                    <>
                      <a
                        style={{
                          margin: 0,
                          color: "red",
                          textDecoration: "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{price}
                      </a>
                      &nbsp;&nbsp;
                      <a
                        style={{
                          textDecoration:
                            theDiscount === 0 || thedeal === 2
                              ? "none"
                              : "line-through",
                          fontSize: 15,
                        }}
                      >
                        ₪{priceInsteadOf}
                      </a>
                    </>
                  )}
                </>
              )}
            </p>
          </div>
          <div>
            <a>
              {hoverTheDiscount !== null ? (
                hoverTheDiscount === 0 ? (
                  ""
                ) : (
                  <a>
                    {hoverThedeal === 1 ? (
                      <>
                        <a
                          style={{
                            backgroundColor: "#6b21a8",
                            color: "white",
                            fontSize: 12,
                            paddingLeft: 5,
                            paddingRight: 5,
                          }}
                        >
                          -{hoverTheDiscount}%
                        </a>
                      </>
                    ) : (
                      <></>
                    )}
                  </a>
                )
              ) : theDiscount === 0 ? (
                ""
              ) : (
                <a>
                  {thedeal === 1 ? (
                    <>
                      {" "}
                      <a
                        style={{
                          backgroundColor: "#6b21a8",
                          color: "white",
                          paddingLeft: 5,
                          paddingRight: 5,
                          fontSize: 15,
                        }}
                      >
                        -{theDiscount}%
                      </a>{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </a>
              )}
            </a>
          </div>
        </div>
        <div
          style={{
            backgroundColor: "#fff",
            padding: "1px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            transition: "transform 0.3s ease, opacity 0.3s ease",
            transform: isDivHovered ? "translateY(0)" : "translateY(-100%)", // Slide from top to bottom
            opacity: isDivHovered ? 1 : 0, // Fade in/out on hover
            height: "50px",
            flexDirection: "column",
          }}
        >
          <div style={{ width: "100%", paddingBottom: 5, paddingTop: 50 }}>
            <div
              ref={dropdownRef}
              style={{ position: "relative", display: "flex" }}
            >
              <button
                onClick={() => {
                  const result = productDropDowns1.find(
                    (item) => item.id === item.productId
                  );
                  {
                    result.dropDownOrDialog === 1 ? (
                      <>{toggleDropdown()}</>
                    ) : (
                      <>
                        {setImageChoosed(result.image)}
                        {setOpen2(true)}
                        {setProductChoosed(productDropDowns1)}
                        {setOBJOfProductChoosed(result)}
                      </>
                    );
                  }
                }}
                style={{
                  padding: "10px 20px",
                  backgroundColor: "white", //"#007bff",
                  color: "white",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent:
                    productDropDowns1.length > 1 ? "space-between" : "center",
                  width: "100%",
                  border:
                    productDropDowns1.length > 1
                      ? "1px solid #e4e4e7"
                      : "1px solid #18181b",
                  //border: "1px solid black",
                }}
              >
                <p style={{ color: "black", margin: 0 }}>{selectedOption}</p>
                <span
                  style={{
                    marginLeft: "10px",
                    display: "inline-block",
                    transition: "transform 0.3s ease", // Smooth transition for the rotation
                    transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", // Rotate the arrow
                    color: "black",
                  }}
                >
                  {productDropDowns1.length > 1 ? (
                    <img
                      src={ArrowDown}
                      style={{
                        width: 12,
                        height: 12,
                        opacity: currentSlide === 0 ? 0.3 : 1,
                        cursor: currentSlide === 0 ? "" : "pointer",
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </span>
              </button>
              <ul
                style={{
                  position: "absolute",
                  top: "100%",
                  left: "0",
                  backgroundColor: "white",
                  boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  padding: "0",
                  margin: "0",
                  listStyleType: "none",
                  width: "100%",
                  maxHeight: isOpen ? "150px" : "0", // Set max height to limit the size of dropdown
                  overflowY: "auto", // Enable vertical scrolling when content overflows
                  opacity: isOpen ? "1" : "0", // Fade-in/out effect
                  transition: "all 0.3s ease", // Smooth transition for height and opacity
                }}
              >
                <style>
                  {`
                     /* Custom Scrollbar Styling */
                     ul::-webkit-scrollbar {
                       width: 8px;
                     }
                     ul::-webkit-scrollbar-thumb {
                       background-color: #c1c1c1; /* Scrollbar thumb color */
                       border-radius: 4px;
                     }
                     ul::-webkit-scrollbar-thumb:hover {
                       background-color: #a0a0a0; /* Scrollbar thumb hover color */
                     }
                     ul::-webkit-scrollbar-track {
                       background-color: #f1f1f1; /* Scrollbar track color */
                       border-radius: 4px;
                     }
                   `}
                </style>

                {productDropDowns1.length > 1 ? (
                  <>
                    {productDropDowns1.map((product) => (
                      <li
                        key={product.id}
                        style={{
                          padding: "10px 20px",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          handleOptionClick(product.dropDown);
                          setTheDiscount(product.discount);
                          setPrice(product.price); // Example: Add 20 to the price
                          setPriceInsteadOf(product.priceInsteadOf); // Example: Add 20 to the price

                          setThedeal(product.theDeal);
                          setDiscount(
                            product.price -
                              (product.price * product.discount) / 100
                          );
                          setIdOfProduct(product.id);
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.backgroundColor = "#f1f1f1";
                          sethoverTheDiscount(product.discount);
                          setHoverPrice(product.price); // Set the temporary hover price
                          setHoverPriceInsteadOf(product.priceInsteadOf);

                          setHoverThedeal(product.theDeal);
                          setHoverDiscount(
                            product.price -
                              (product.price * product.discount) / 100
                          );
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.backgroundColor = "white";
                          sethoverTheDiscount(null);
                          setHoverPrice(null); // Reset to null to show the actual price
                          setHoverPriceInsteadOf(null);

                          setHoverThedeal(null);
                          setHoverDiscount(null);
                        }}
                      >
                        {product.dropDown}
                      </li>
                    ))}
                  </>
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </div>
          <button
            style={{
              backgroundColor: "#27272a",
              color: "#fff",
              border: "none",
              padding: "10px 20px",
              cursor: "pointer",
              fontSize: "16px",
              width: "100%",
            }}
            onClick={() => {
              CreateProduct();
            }}
          >
            {t("profile.Buy")}
          </button>
        </div>
      </div>
    );
  }

  const [currentSlide, setCurrentSlide] = useState(0);
  const wrapperRef = useRef();
  const [color, setColor] = useState("black");
  const [page, setPage] = useState(1);
  const itemsPerPage = 28; // Display 12 items per page for better pagination

  // Handle pagination page changes
  const handlePageChange = (event, value) => {
    setPage(value);
    scrollToTop();
  };
  // Reset page on filter
  useEffect(() => {
    console.log("Redirect to first page !");
    setPage(1);
  }, [ProductsDataWithoutDub]);
  // Calculate the start and end indices for slicing products
  const startIndex = (page - 1) * itemsPerPage;
  const currentProducts = ProductsDataWithoutDub.slice(
    startIndex,
    startIndex + itemsPerPage
  );

  const ShowAdTopSection = [
    ...Array.from({ length: 15 }, (v, i) => 8000 + i),
    ...Array.from({ length: 7 }, (v, i) => 9000 + i),
  ];

  const FindShowAdTopSection = ShowAdTopSection.find(
    (value) => value === Number(CategoryName)
  );

  const CheckBreadcrumbs = [
    1000, 2000, 3000, 4000, 5000, 6000, 7000, 8000, 9000,
  ];

  const [MyOpen, setMyOpen] = React.useState(false);

  const handleOpenDialog = () => {
    setMyOpen(true);
  };

  const handleCloseDialog = () => {
    setMyOpen(false);
  };
  // Function to update the state from the child
  const handleToggleShowTopSection = (value) => {
    setShowTopSection(value);
  };
  const [open3, setOpen3] = React.useState(false);
  // Function to toggle the `open` state
  const handleToggle = () => {
    setOpen3((prevOpen) => !prevOpen); // Toggle the `open` state
  };
  const [openDrawer, setOpenDrawer] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };
  const handleSortClick = (value) => {
    handleMenuClick({
      key: items.find((item) => item.value === value)?.key,
    });
    setOpenDrawer(false);
  };

  const [MobileOpenDrawerOBJ, setMobileOpenDrawerOBJ] = useState([]);
  const [OpenMobileDrawer, setOpenMobileDrawer] = React.useState(false);

  const handleChildFunction1 = (dataFromSource) => {
    setMobileOpenDrawerOBJ(dataFromSource);
  };

  const OpenMobileDrawerFunc = (theOBJ) => {
    //const newData = `Data from parent at ${new Date().toLocaleTimeString()}`;
    setMobileOpenDrawerOBJ(theOBJ);
    //handleChildFunction1(true);
    setOpenMobileDrawer(true);
  };

  const CloseMobileDrawerFromChildFunc = (dataFromSource) => {
    setOpenMobileDrawer(false);
  };

  return (
    <div>
      {MyModal2()}
      <AppContext.Provider
        value={{
          MobileOpenDrawerOBJ,
          handleChildFunction1,
          OpenMobileDrawer,
          CloseMobileDrawerFromChildFunc,
          CreateProduct4,
        }}
      >
        <AllCategoriesOpenMobileDrawer openDrawer2={true} />
      </AppContext.Provider>
      <Drawer open={openDrawer} onClose={toggleDrawer(false)} anchor="bottom">
        <div
          style={{
            display: "flex",
            width: "100%",
            //justifyContent: "flex-end",
            paddingTop: 20,
            paddingBottom: 30,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginLeft: "2%",
              marginRight: "2%",
              paddingBottom: 20,
            }}
          >
            <a style={{ fontSize: 20, fontWeight: "500" }}>Sorting</a>
            <img
              onClick={() => {
                setOpenDrawer(false);
              }}
              src={CloseImg}
              alt={"Expand"}
              style={{ width: 25, height: 25, cursor: "pointer" }}
            />
          </div>
          {items.map((option) => (
            <a
              key={option.key}
              style={{
                color: option.value === sortType ? "blue" : "black",
                textDecoration: "none",
                cursor: "pointer",
                fontSize: 16,
                marginLeft: "2%",
                paddingBottom: 15,
              }}
              onClick={() => handleSortClick(option.value)}
            >
              {option.label}
            </a>
          ))}
        </div>
      </Drawer>
      <AllCategoriesCartDialog
        MyOpen={MyOpen}
        onClose={handleCloseDialog}
        CartData={CartData}
        MySaveTotalPrice={SaveTotalPrice}
        onCreateProduct2={CreateProduct2}
        handleDivClick2={handleDivClick2}
        MyRecommendedProductsData={RecommendedProductsData}
      />

      {MyWidth <= 1024 ? (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Vertical Line */}

          <div
            style={{
              //padding: 10,
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              width: "100%",
              height: "4vh",
            }}
          >
            <img
              src={arrowleft} // Replace with your image URL
              alt="Placeholder"
              style={{
                width: 30,
                height: 30,
                objectFit: "cover",
                //borderRadius: "8px",
                cursor: "pointer",
                marginLeft: 10,
              }}
              onClick={() => {
                handleDivClick(NameCat, CodeCat);
                scrollToTop2();
              }}
            />
            <div
              style={{
                display: "flex",
                width: "1px",
                height: "100%", // "100%",
                backgroundColor: "#f4f4f5",
                marginRight: 10,
                marginLeft: 10,
              }}
            ></div>
          </div>
          <div
            style={{
              height: "0.1px",
              backgroundColor: "#f4f4f5",
              width: "100%",
            }}
          ></div>
        </div>
      ) : (
        <></>
      )}
      <div
        style={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
          paddingTop: 45,
          paddingBottom: 45,
          width: "100%",
          paddingLeft: MyWidth <= 1024 ? "2%" : 0,
          paddingRight: MyWidth <= 1024 ? "2%" : 0,
        }}
      >
        <div style={{ display: "flex", width: "100%" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              width: "100%",
            }}
          >
            <p style={{ fontSize: 20, fontWeight: 500 }}>{CategoryTitle}</p>
            {MyWidth <= 1024 ? (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <button
                    style={{
                      width: "49%",
                      height: 50,
                      backgroundColor: "white",
                      border: "1px solid black",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={handleToggle}
                  >
                    <img
                      src={FilterImage} // Replace with your image URL
                      alt="Placeholder"
                      style={{
                        width: 15,
                        height: 15,
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                    />
                    &nbsp;<a>{t("profile.Filters")}</a>
                  </button>

                  <button
                    style={{
                      width: "49%",
                      height: 50,
                      backgroundColor: "white",
                      border: "1px solid black",
                    }}
                    onClick={toggleDrawer(true)}
                  >
                    <a>{t("profile.Sort")}</a>&nbsp;
                    <img
                      src={ArrowDown} // Replace with your image URL
                      alt="Placeholder"
                      style={{
                        width: 15,
                        height: 15,
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                      onClick={() => {}}
                    />
                  </button>
                </div>

                <AllCategoriesFiltersSearchPage
                  setProductsDataWithoutDub={setProductsDataWithoutDub}
                  onToggle={handleToggleShowTopSection}
                  setProductsData={setProductsData}
                  open3={open3}
                  setOpen3={setOpen3}
                  sendDataToParent={handleDataFromChild}
                  dataFromChild={dataFromChild}
                  onButtonClick={handleClick}
                  data={data}
                  content={content}
                  showContent={showContentInChild}
                  clearAll={clearAll}
                  sendPricingToParent={handleDataFromChild2}
                  delPricing={delPricing}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
        {MyWidth <= 1024 ? (
          <></>
        ) : (
          <div
            style={{
              //backgroundColor: "red",
              width: "20%",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <AllCategoriesFiltersSearchPage
              setProductsDataWithoutDub={setProductsDataWithoutDub}
              onToggle={handleToggleShowTopSection}
              setProductsData={setProductsData}
              sendDataToParent={handleDataFromChild}
              dataFromChild={dataFromChild}
              onButtonClick={handleClick}
              data={data}
              content={content}
              showContent={showContentInChild}
              clearAll={clearAll}
              sendPricingToParent={handleDataFromChild2}
              delPricing={delPricing}
            />
          </div>
        )}

        <div
          style={{
            width: MyWidth <= 1024 ? "100%" : "80%",
            paddingLeft: MyWidth <= 1024 ? "2%" : 0,
            paddingRight: MyWidth <= 1024 ? "2%" : 0,
          }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "center",
              alignItems: "center",
              marginBottom: 10,
            }}
          >
            <a style={{ fontSize: 30, fontWeight: "450" }}>
              {t("profile.Searchresults")}
            </a>
          </div>
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "flex-start", // Align items to the top to prevent button movement
              flexWrap: "nowrap", // Ensure the button always stays in place
            }}
          >
            {/* Left side: Wrapped items */}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "10px", // Adds spacing between items
                flex: 1, // Allows this section to take up remaining space
              }}
            >
              {dataFromChild.map((item, index) => (
                <div
                  key={index}
                  style={{
                    margin: 8,
                    padding: "5px 15px",
                    backgroundColor: "#f5f5f4",
                    borderRadius: 20,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => handleDelete(item.filter, item.id)}
                >
                  <a
                    style={{
                      color: "black",
                      textDecoration: "none",
                    }}
                  >
                    {item.name}
                  </a>
                  &nbsp;
                  <img
                    src={CloseImg}
                    alt="Expand"
                    style={{ width: 15, height: 15, cursor: "pointer" }}
                  />
                </div>
              ))}

              {/* Price Range Item */}
              {PricingToParent.min !== undefined &&
              PricingToParent.max !== undefined &&
              !(
                PricingToParent.min === 0 && PricingToParent.max === Infinity
              ) ? (
                <div
                  style={{
                    margin: 8,
                    padding: "5px 15px",
                    backgroundColor: "#f5f5f4",
                    borderRadius: 20,
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    handleButtonClick2();
                    handleDelete();
                  }}
                >
                  <a
                    style={{
                      color: "black",
                      textDecoration: "none",
                    }}
                  >
                    from {PricingToParent.min} to {PricingToParent.max} ₪
                  </a>
                  &nbsp;
                  <img
                    src={CloseImg}
                    alt="Expand"
                    style={{ width: 15, height: 15, cursor: "pointer" }}
                  />
                </div>
              ) : null}
            </div>

            {/* Right side: Clean All Button (Fixed Position) */}
            {!ShowTopSection && (
              <div
                style={{
                  alignSelf: "flex-start", // Keeps the button at the top, preventing it from moving down
                }}
              >
                <a
                  style={{
                    fontSize: 14,
                    cursor: "pointer",
                    color,
                    whiteSpace: "nowrap", // Prevents breaking into a new line
                  }}
                  onClick={() => {
                    ClearAllFunc();
                    handleButtonClick2();
                  }}
                  onMouseEnter={() => setColor("#6366f1")}
                  onMouseLeave={() => setColor("black")}
                >
                  {t("profile.ClearAll")}
                </a>
              </div>
            )}
          </div>
          {ShowTopSection ? (
            <>
              {" "}
              {FindShowAdTopSection ? (
                <></>
              ) : (
                <>
                  <AllCategoriesBlock1 />
                </>
              )}
            </>
          ) : (
            <></>
          )}
          <div>
            {MyWidth <= 1024 ? (
              <></>
            ) : (
              <div
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  paddingTop: ShowTopSection ? 50 : 0,
                  paddingBottom: ShowTopSection ? 20 : 0,
                }}
              >
                {/* Add the style tag */}
                <style>
                  {`
                               .ant-dropdown-menu {
                                 border-radius: 0 !important;
                               }
          
                               .ant-dropdown-menu-item {
                                 opacity: 0.5; /* Default opacity for dropdown items */
                                 transition: opacity 0.3s ease; /* Smooth transition for hover effect */
                               }
          
                               .ant-dropdown-menu-item:hover {
                                 opacity: 1; /* Full opacity on hover */
                                 background-color: transparent !important; /* Remove blue background on hover */
                               }
          
                               .ant-dropdown-menu-item-selected {
                                 opacity: 1 !important; /* Full opacity for selected item */
                                 background-color: transparent !important; /* Remove blue background for selected item */
                                 color: inherit !important; /* Inherit text color (remove blue color) */
                               }
          
                               .ant-dropdown-menu-item a {
                                 color: inherit !important; /* Inherit text color for links (remove blue color) */
                               }
          
                               .ant-dropdown-menu-item a:hover {
                                 color: inherit !important; /* Inherit text color on hover (remove blue color) */
                               }
                             `}
                </style>
                <Dropdown
                  menu={{
                    items,
                    onClick: handleMenuClick, // Add click handler
                    selectedKeys: [
                      items.find((item) => item.value === sortType)?.key,
                    ], // Set selected key based on sortType
                  }}
                  trigger={["click"]}
                  overlayStyle={{ borderRadius: 0 }} // Optional: Remove border radius
                >
                  <a
                    style={{
                      color: "black",
                      textDecoration: "none",
                      cursor: "pointer",
                      //display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: 13,
                    }}
                    onClick={(e) => e.preventDefault()}
                  >
                    <span style={{ opacity: 0.5 }}>{t("profile.Sortby")}:</span>
                    &nbsp;
                    {selectedValue}
                    {/* Display the selected value */}
                    &nbsp; &nbsp;
                    <a style={{ fontSize: 11 }}>
                      <DownOutlined />
                    </a>
                  </a>
                </Dropdown>
              </div>
            )}

            {/* Grid to display products */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  MyWidth <= 1024
                    ? "repeat(2, 1fr)"
                    : MyWidth < 1440
                    ? "repeat(3, 1fr)"
                    : "repeat(4, 1fr)",
                gap: "20px",
                paddingBottom: 50,
                direction: i18n.resolvedLanguage === "en" ? "" : "rtl",
              }}
            >
              {getSortedList().map((product, index) => {
                const isSpecial = index % 6 === 0; // Special condition placement
                const spanSpecial = index % 12 === 0;

                return isSpecial ? (
                  <React.Fragment key={index}>
                    {/* Special Section Content */}
                    {index + (page - 1) * itemsPerPage < 55 ? (
                      <>
                        {AdSectionData.map((product, MyIndex) => (
                          <>
                            {product.whichPlace ===
                            index + (page - 1) * itemsPerPage ? (
                              <>
                                {spanSpecial && (
                                  <div
                                    style={{
                                      gridColumn: "span 2",
                                      display: "flex",
                                      flexDirection: "column",
                                    }}
                                  >
                                    <div
                                      style={{
                                        backgroundColor: "#f0f0f0",
                                        height:
                                          MyWidth <= 1024 ? "100%" : "65%",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                      }}
                                    >
                                      {AdSectionData.find(
                                        (item) =>
                                          item.whichPlace ===
                                          index + (page - 1) * itemsPerPage
                                      ) ? (
                                        <>
                                          <img
                                            src={product?.image} // Replace with your image URL
                                            alt="Placeholder"
                                            style={{
                                              width: "100%",
                                              height: "100%",
                                              objectFit: "cover",
                                              //borderRadius: "8px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() => {
                                              const number = product?.linkToTake
                                                .split("/")
                                                .pop();
                                              console.log(number);
                                              scrollToTop2();
                                              GoTo(number);

                                              // handleDivClick3(
                                              //   product?.linkToTake
                                              // );
                                            }}
                                          />
                                        </>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                    <div
                                      style={{
                                        direction:
                                          i18n.resolvedLanguage === "en"
                                            ? ""
                                            : "rtl",
                                        paddingTop: 15,
                                      }}
                                    >
                                      <a
                                        style={{
                                          fontSize: 14,
                                          color: "#6b21a8",
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <a>
                                          {" "}
                                          {t(
                                            "profile.Specialofferwillendin"
                                          )}{" "}
                                        </a>
                                        {/* <a ref={displayRefs[MyIndex]}></a> */}
                                        <div>
                                          {AdSectionData?.map((_, index) => (
                                            <div
                                              key={MyIndex}
                                              ref={(el) =>
                                                (displayRefs.current[MyIndex] =
                                                  {
                                                    current: el,
                                                  })
                                              }
                                            >
                                              <></>
                                            </div>
                                          ))}
                                        </div>
                                      </a>
                                    </div>
                                  </div>
                                )}
                              </>
                            ) : (
                              <></>
                            )}
                          </>
                        ))}
                      </>
                    ) : (
                      <></>
                    )}

                    <ProductCard
                      id={product?.id}
                      productId={product?.productId}
                      image={product?.image}
                      title={product?.name}
                      subtitle={product?.productType}
                      price={product?.price}
                      discount={product?.discount}
                      deals={product?.deals}
                      thedeal={product?.theDeal}
                      theOBJ={product}
                      news={product.news}
                      reviews={product.reviews}
                      priceinsteadof={product.priceInsteadOf}
                    />
                  </React.Fragment>
                ) : (
                  <ProductCard
                    key={index}
                    id={product?.id}
                    productId={product?.productId}
                    image={product?.image}
                    title={product?.name}
                    subtitle={product?.productType}
                    price={product?.price}
                    discount={product?.discount}
                    deals={product?.deals}
                    thedeal={product?.theDeal}
                    theOBJ={product}
                    news={product.news}
                    reviews={product.reviews}
                    priceinsteadof={product.priceInsteadOf}
                  />
                );
              })}
            </div>

            {/* Pagination Controls */}
            <Stack spacing={2} alignItems="center" marginTop={4}>
              <Pagination
                count={Math.ceil(ProductsDataWithoutDub.length / itemsPerPage)}
                page={page}
                onChange={handlePageChange}
                color="primary"
                hidePrevButton
                hideNextButton
                sx={{
                  "& .MuiPaginationItem-root": {
                    borderRadius: "0px", // Make buttons square
                    "&:hover": {
                      backgroundColor: "black", // Hover background color
                      color: "white", // Optional text color on hover
                    },
                    "&.Mui-selected": {
                      backgroundColor: "black", // Background color when clicked
                      color: "white", // Text color when clicked
                    },
                  },
                }}
              />
            </Stack>
          </div>
        </div>
      </div>
      <AllCategoriesReviews CategoryName={CategoryName} />
      <AllCategoriesRecentlyViewed />
      {/* <AllCategoriesExplain /> */}
    </div>
  );
}
